import React from 'react';
import PropTypes from 'prop-types';

const Site = (props) => (
	<site name={props.name} state="1" siteresourcespackagekey={props.packageKey} sitenodename={props.nodeName}>
		<nodes formatversion="2.0">
			{props.children ? props.children : null}
		</nodes>
	</site>
);

Site.propTypes = {
	name: PropTypes.string.isRequired,
	packageKey: PropTypes.string.isRequired,
	nodeName: PropTypes.string.isRequired,
	children: PropTypes.object.isRequired
};

export default Site;



// WEBPACK FOOTER //
// ./src/components/Xml/Site.js